import { Navbar } from "react-bootstrap";

export function XtNavBarBrand(props) {
    return (<Navbar.Brand {...props}>{props.children}</Navbar.Brand>);
}
